export default __webpack_public_path__ + "static/pt_2-0a8c42307d9de14aeec65505e0efb2b8.png";